module.exports = __webpack_public_path__ + "img/payment.97610e5d.jpg";